import React from 'react';
import { Link } from 'react-router-dom';
import { FiCalendar, FiArrowRight, FiCheck } from 'react-icons/fi';
import PkrIcon from '../common/PkrIcon';
import { REAL_SHOP_IMAGES } from '../../config/realMedia';
import './SegmentsSection.css';

const SHOWROOM_IMG_MQ = REAL_SHOP_IMAGES.deepFreezerFloor;
const SHOWROOM_IMG_XH = REAL_SHOP_IMAGES.refrigeratorAisle;

const SegmentsSection = () => {
    return (
        <section className="segments-section" aria-label="Shop your way purchase pathways">
            <div className="container">
                <div className="segments-header">
                    <span className="section-eyebrow">PURCHASE OPTIONS</span>
                    <h2 className="section-title">Two Convenient Ways to Buy</h2>
                    <p className="segments-subtitle">
                        Choose flexible monthly installments tailored to your household income, or take advantage of instant cash discounts
                    </p>
                </div>

                <div className="segments-grid">
                    {/* Pathway 1: Buy on Installment */}
                    <div className="segment-card segment-card--navy">
                        <div className="segment-bg-wrap" aria-hidden="true">
                            <img src={SHOWROOM_IMG_MQ} alt="" className="segment-bg-img" loading="lazy" />
                            <div className="segment-bg-overlay segment-bg-overlay--navy" />
                        </div>
                        
                        <div className="segment-content">
                            <div className="segment-icon-box">
                                <FiCalendar className="segment-icon" aria-hidden="true" />
                            </div>

                            <span className="segment-badge segment-badge--navy">FLEXIBLE FINANCING</span>
                            <h3 className="segment-title">Buy on Installment</h3>
                            <p className="segment-desc">
                                Pay 25%, 50% or 75% upfront and spread the rest over 6, 9 or 12 months. Plus a special 0% markup plan over 4 months.
                            </p>

                            <ul className="segment-bullets">
                                <li>
                                    <FiCheck className="segment-check" aria-hidden="true" />
                                    <span>Valid CNIC and 2 guarantors (Lahore)</span>
                                </li>
                                <li>
                                    <FiCheck className="segment-check" aria-hidden="true" />
                                    <span>Verification within 24 working hours</span>
                                </li>
                                <li>
                                    <FiCheck className="segment-check" aria-hidden="true" />
                                    <span>Transparent terms with zero hidden costs</span>
                                </li>
                            </ul>

                            <div className="segment-action">
                                <Link to="/installment" className="segment-btn segment-btn--white">
                                    Explore Installment Plans <FiArrowRight aria-hidden="true" />
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Pathway 2: Buy on Cash */}
                    <div className="segment-card segment-card--peach">
                        <div className="segment-bg-wrap" aria-hidden="true">
                            <img src={SHOWROOM_IMG_XH} alt="" className="segment-bg-img" loading="lazy" />
                            <div className="segment-bg-overlay segment-bg-overlay--peach" />
                        </div>

                        <div className="segment-content">
                            <div className="segment-icon-box segment-icon-box--peach">
                                <PkrIcon className="segment-icon" aria-hidden="true" />
                            </div>

                            <span className="segment-badge segment-badge--peach">INSTANT SAVINGS</span>
                            <h3 className="segment-title segment-title--dark">Buy on Cash</h3>
                            <p className="segment-desc segment-desc--dark">
                                Settle upfront and get an instant cash discount on the listed MRP. Direct bank transfer or showroom payment.
                            </p>

                            <ul className="segment-bullets segment-bullets--dark">
                                <li>
                                    <FiCheck className="segment-check" aria-hidden="true" />
                                    <span>Instant discount on every home appliance</span>
                                </li>
                                <li>
                                    <FiCheck className="segment-check" aria-hidden="true" />
                                    <span>Same-day priority delivery in Lahore</span>
                                </li>
                                <li>
                                    <FiCheck className="segment-check" aria-hidden="true" />
                                    <span>Order verified via phone call before dispatch</span>
                                </li>
                            </ul>

                            <div className="segment-action">
                                <Link to="/cash" className="segment-btn segment-btn--orange">
                                    Browse Cash Deals <FiArrowRight aria-hidden="true" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SegmentsSection;
